<template lang="pug">
  v-btn(@click="add" :disabled="alreadyInCart || amountIsZero" flat ) {{btnText}}
    
</template>
<script>
export default {
  props:{
    item: {
      default: {amount:1}
    },
    itemType:{
      default: 'item'
    }
  },
  computed:{
    alreadyInCart(){
      let arr = {}
      if(this.itemType=='package'){
        arr = this.$store.state.cart.packages.find(p=>{
          return p.packageName == this.item.packageName
        })
      }else if(this.itemType == 'item'){
        arr = this.$store.state.cart.items.find(i=>{
          return i.itemName == this.item.itemName
        })
      }
      // console.log(arr)
      if(arr==null || arr== undefined){ 
        this.$emit('inCart', {item: this.item, status:false})
        return false 
      }else{
        this.$emit('inCart', {item: this.item, status:true , amount: arr.amount})
        return true
      }
    },
    btnText(){
      if(this.item.amount===""){
        return  'Amount cannot be 0'
      }
      return this.alreadyInCart ? 'Already in cart' : 'Add to cart'
    },
    amountIsZero(){
      return this.item.amount === ""
    }
  },
  methods:{
    add(){
      window.ga('send', 'event', 'Cart', 'add', this.item.itemName)
      let payload = {item: this.item, itemType:this.itemType}
      this.$store.dispatch('addToCart', payload)
      this.$emit('added')
    }
  }
}
</script>
